<script>
import Modal from "@/components/_Shared/Professionals/Biography/Modal";

export default {
  props: {
    account: {
      type: Object,
      required: true
    }
  },
  components: {
    Modal
  },
  data() {
    return {
      fullBio: false
    };
  },
  methods: {
    bioIsExpansible() {
      let bio = this.account.profile.bio;
      return bio && bio.length > 99;
    }
  }
};
</script>

<template>
  <section>
    <div>{{account.profile.bio}}</div>
    <div
      v-if="bioIsExpansible()"
      @click="fullBio = true"
      class="btn btn-small btn-purple-outline"
    >ler mais</div>
    <modal v-if="fullBio" :account="account" @close="fullBio = false" />
  </section>
</template>

<style scoped>
.btn {
  margin-top: 5px;
}

div {
  font-size: 14px;
  font-weight: normal;
  font-style: italic;
  text-align: justify;
  text-align-last: center;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Professionals/Biography/Index.vue